export type TestimonialUse = 'personal' | 'profesional'

export const testimonials: {
  quote: string
  name: string
  location: string
  use: TestimonialUse
  photo: string
}[] = [
  {
    quote:
      'Yo soy de las que compra estas cosas y después no las usa 😅 pero esta vez imprimí un par de páginas el mismo día. Empecé con una de colores porque no tenía muchas ganas de escribir y terminé re entretenida.',
    name: 'Camila',
    location: 'Buenos Aires, Argentina',
    use: 'personal',
    photo: 'https://cdn.magicpatterns.com/uploads/cCKdjd4KmjFaRhm2rQGoiM/testimonio_rulos_magic_1080x1080.webp',
  },
  {
    quote:
      'Pensé que iba a ser más tipo journal, de responder preguntas y ya. Me gustó que realmente hay cosas para pintar, recortar y hacer con las manos. A mí eso me desconecta mucho más.',
    name: 'Sofía',
    location: 'Ciudad de México, México',
    use: 'personal',
    photo: 'https://cdn.magicpatterns.com/uploads/s7HotKTozRnqxDH1jynGXE/testimonio_darktop_livingroom_magic_1080x1080.webp',
  },
  {
    quote:
      'Llegué del trabajo bastante saturada y probé una actividad como para ver qué tal. Estuve capaz 15 minutos, no mucho más, pero fue la primera vez en todo el día que dejé el celular lejos.',
    name: 'Valentina',
    location: 'Santiago, Chile',
    use: 'personal',
    photo: 'https://cdn.magicpatterns.com/uploads/g9pXBSN3xM8ANThnkZHrFR/testimonio_rodete_magic_1080x1080.webp',
  },
  {
    quote:
      'Me daba un poco de vergüenza porque dibujo fatal jaja. Después entendí que justamente no importaba. Hice una página con acuarelas y quedó cualquier cosa, pero la disfruté muchísimo.',
    name: 'Lucía',
    location: 'Madrid, España',
    use: 'personal',
    photo: 'https://cdn.magicpatterns.com/uploads/3rit5VHVmiQwXurFpNnaM3/testimonio_rubia_lentes_magic_1080x1080.webp',
  },
  {
    quote:
      'Hay días que escribir lo que siento me da hasta pereza porque siento que sigo dándole vueltas a lo mismo. Con estas actividades es distinto. A veces simplemente elijo colores y empiezo por ahí.',
    name: 'Daniela',
    location: 'Bogotá, Colombia',
    use: 'personal',
    photo: 'https://cdn.magicpatterns.com/uploads/9WKWMQVn6qCM5UVsan9A4V/testimonio_colombia_1080x1080_magic.webp',
  },
  {
    quote:
      'Lo que más me sirve es tener una base ya preparada. Obviamente después adapto las consignas dependiendo de la persona, pero me ahorra estar inventando una actividad desde cero cada semana.',
    name: 'Laura',
    location: 'Barcelona, España',
    use: 'profesional',
    photo: 'https://cdn.magicpatterns.com/uploads/jzy3ensE1BTAsmQ23sLyLU/testimonio_google_1080x1080_magic.webp',
  },
]

export const purchaseNotices = [
  { name: 'María', location: 'Bogotá, Colombia' },
  { name: 'Sofía', location: 'Ciudad de México, México' },
  { name: 'Laura', location: 'Madrid, España' },
  { name: 'Valentina', location: 'Santiago, Chile' },
  { name: 'Mariana', location: 'Lima, Perú' },
  { name: 'Camila', location: 'Buenos Aires, Argentina' },
]
